// Generated by Melange

import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_controlapis__Buhta_control_v1alpha1_entity_service from "../../../../proto/controlapis/gen/buhta_control_v1alpha1_entity_service.js";
import * as Buhta_controlapis__Buhta_control_v1alpha1_etp_service from "../../../../proto/controlapis/gen/buhta_control_v1alpha1_etp_service.js";
import * as Buhta_controlapis__Buhta_control_v1alpha1_org_service from "../../../../proto/controlapis/gen/buhta_control_v1alpha1_org_service.js";
import * as Buhta_controlapis__Buhta_control_v1alpha1_prop_information_service from "../../../../proto/controlapis/gen/buhta_control_v1alpha1_prop_information_service.js";
import * as Buhta_core__Grpc from "../../../../packages/core/lib/Grpc.js";
import * as Buhta_core__GrpcState from "../../../../packages/core/lib/GrpcState.js";
import * as Buhta_dictapis__Buhta_dict_v1_org_type_service from "../../../../proto/dictapis/gen/buhta_dict_v1_org_type_service.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib from "melange/stdlib.js";

const Org = {};

const PropInformation = {};

const Etp = {};

function toCreateRequest(form) {
  return Curry._2(Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.CreateOrgRequest.make, form, undefined);
}

const OrgForm = {
  toCreateRequest: toCreateRequest
};

function toUpdateRequest(info) {
  return Curry._3(Buhta_controlapis__Buhta_control_v1alpha1_prop_information_service.Buhta.Control.V1alpha1.UpdatePropInformationRequest.make, info, undefined, undefined);
}

const PropInformationForm = {
  toUpdateRequest: toUpdateRequest
};

const LookupCtx = {};

const LookupOrg = {};

function lookup(tin, country, ctx) {
  const request = Curry._4(Buhta_controlapis__Buhta_control_v1alpha1_entity_service.Buhta.Control.V1alpha1.LookupEntityRequest.make, country, tin, ctx, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    const match = response.lookup_opt;
    if (typeof match === "string") {
      throw new Caml_js_exceptions.MelangeError(Stdlib.Not_found, {
            MEL_EXN_ID: Stdlib.Not_found
          });
    }
    if (match.NAME === "Org") {
      return match.VAL;
    }
    throw new Caml_js_exceptions.MelangeError(Stdlib.Not_found, {
          MEL_EXN_ID: Stdlib.Not_found
        });
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_controlapis__Buhta_control_v1alpha1_entity_service.Buhta.Control.V1alpha1.EntityService.lookupEntity, undefined, undefined, undefined, Buhta_controlapis__Buhta_control_v1alpha1_entity_service.Buhta.Control.V1alpha1.EntityService.LookupEntity.name, undefined, undefined));
}

const EntityService = {
  lookup: lookup
};

function view(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : ({
      hd: "bank_account",
      tl: {
        hd: "chief",
        tl: /* [] */ 0
      }
    });
  const request = Curry._3(Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.GetOrgRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.org);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.OrgService.getOrg, undefined, undefined, tenant, Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.OrgService.GetOrg.name, undefined, undefined));
}

function grid(tenant, params, param) {
  const request = Curry._2(Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.ListOrgsRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.orgs;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.OrgService.listOrgs, undefined, undefined, tenant, Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.OrgService.ListOrgs.name, undefined, undefined));
}

function getOrgTypes(param, country, param$1, param$2) {
  const request = Curry._2(Buhta_dictapis__Buhta_dict_v1_org_type_service.Buhta.Dict.V1.GetOrgTypesRequest.make, country, undefined);
  return Buhta_core__Grpc.makeRpc(undefined, request, Buhta_dictapis__Buhta_dict_v1_org_type_service.Buhta.Dict.V1.OrgTypeService.getOrgTypes, undefined, undefined, undefined, "/dict" + Buhta_dictapis__Buhta_dict_v1_org_type_service.Buhta.Dict.V1.OrgTypeService.GetOrgTypes.name, undefined, undefined);
}

function create(tenant, form) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.org);
  }), Buhta_core__Grpc.makeRpc(undefined, toCreateRequest(form), Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.OrgService.createOrg, undefined, undefined, tenant, Buhta_controlapis__Buhta_control_v1alpha1_org_service.Buhta.Control.V1alpha1.OrgService.CreateOrg.name, undefined, undefined));
}

function view$1(tenant, expandOpt, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  const request = Curry._2(Buhta_controlapis__Buhta_control_v1alpha1_prop_information_service.Buhta.Control.V1alpha1.GetPropInformationRequest.make, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.info);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_controlapis__Buhta_control_v1alpha1_prop_information_service.Buhta.Control.V1alpha1.PropInformationService.getPropInformation, undefined, undefined, tenant, Buhta_controlapis__Buhta_control_v1alpha1_prop_information_service.Buhta.Control.V1alpha1.PropInformationService.GetPropInformation.name, undefined, undefined));
}

function update(tenant, info) {
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.info);
  }), Buhta_core__Grpc.makeRpc(undefined, toUpdateRequest(info), Buhta_controlapis__Buhta_control_v1alpha1_prop_information_service.Buhta.Control.V1alpha1.PropInformationService.updatePropInformation, undefined, undefined, tenant, Buhta_controlapis__Buhta_control_v1alpha1_prop_information_service.Buhta.Control.V1alpha1.PropInformationService.UpdatePropInformation.name, undefined, undefined));
}

const PropInformationService = {
  view: view$1,
  update: update
};

function view$2(tenant, expandOpt, id, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */ 0;
  const request = Curry._3(Buhta_controlapis__Buhta_control_v1alpha1_etp_service.Buhta.Control.V1alpha1.GetEtpRequest.make, id, expand, undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return Belt__Belt_Option.getExn(response.etp);
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_controlapis__Buhta_control_v1alpha1_etp_service.Buhta.Control.V1alpha1.EtpService.getEtp, undefined, undefined, tenant, Buhta_controlapis__Buhta_control_v1alpha1_etp_service.Buhta.Control.V1alpha1.EtpService.GetEtp.name, undefined, undefined));
}

function grid$1(tenant, params, param) {
  const request = Curry._2(Buhta_controlapis__Buhta_control_v1alpha1_etp_service.Buhta.Control.V1alpha1.ListEtpsRequest.make, Buhta_core__GrpcState.makeGridRequest(params, undefined), undefined);
  return Buhta_core__GrpcState.unwrapPromiseResponse((function (response) {
    return response.etps;
  }), Buhta_core__Grpc.makeRpc(undefined, request, Buhta_controlapis__Buhta_control_v1alpha1_etp_service.Buhta.Control.V1alpha1.EtpService.listEtps, undefined, undefined, tenant, Buhta_controlapis__Buhta_control_v1alpha1_etp_service.Buhta.Control.V1alpha1.EtpService.ListEtps.name, undefined, undefined));
}

const OrgService = {
  grid: grid,
  view: view,
  getOrgTypes: getOrgTypes,
  create: create
};

const EtpService = {
  grid: grid$1,
  view: view$2
};

export {
  Org,
  PropInformation,
  Etp,
  OrgForm,
  PropInformationForm,
  LookupCtx,
  LookupOrg,
  EntityService,
  OrgService,
  PropInformationService,
  EtpService,
}
/* Buhta_controlapis__Buhta_control_v1alpha1_entity_service Not a pure module */
